module.exports = {
  footerText: "Copyright BruFat Company © " + new Date().getFullYear(),
};
